import api from './api';
import { AutoPostRule } from '../types';

export const autoPostService = {
    // Get all rules
    getAll: async (): Promise<AutoPostRule[]> => {
        const response = await api.get('/auto-post/rules');
        return response.data;
    },

    // Create rule
    create: async (data: Partial<AutoPostRule>) => {
        const response = await api.post('/auto-post/rules', data);
        return response.data;
    },

    // Update rule
    update: async (id: string, data: Partial<AutoPostRule>) => {
        const response = await api.patch(`/auto-post/rules/${id}`, data);
        return response.data;
    },

    // Delete rule
    delete: async (id: string) => {
        await api.delete(`/auto-post/rules/${id}`);
    },
};
